import AutoRecipeList from './AutoRecipeList';

export default AutoRecipeList;
